module.exports = __webpack_public_path__ + "static/media/app_ic_backer.9fcf42d5.png";